import { createQueryKeyStore } from '@lukemorales/query-key-factory';
import { AxiosInstance } from 'axios';

import { API_PREFIX_ADMIN } from '../../../constants.ts';

import {
    TAdminPracticeInviteAllResponse,
    TAdminPracticeInvitePayload,
    TAdminPracticeInviteResponse,
    TAdminPracticesPayload,
    TAdminPracticesResponse,
    TAdminPracticeUpdateInfoAllResponse,
} from './types.ts';

export class AdminApiPracticesService {
    #QUERY_KEYS = createQueryKeyStore({
        practices: {
            list: (payload: TAdminPracticesPayload) => ({
                queryKey: ['admin-practices', payload],
                queryFn: () => this.#getPaginatedPractices(payload),
            }),
        },
    });

    constructor(private api: AxiosInstance) {
        this.api = api;
    }

    getPractices(payload: TAdminPracticesPayload) {
        return this.#QUERY_KEYS.practices.list(payload);
    }

    sendInvitation = async (
        payload: TAdminPracticeInvitePayload
    ): Promise<TAdminPracticeInviteResponse> => {
        const { data } = await this.api.post<TAdminPracticeInviteResponse>(
            API_PREFIX_ADMIN + '/practices/invite',
            payload
        );

        return data;
    };

    inviteAll = async (): Promise<TAdminPracticeInviteAllResponse> => {
        const { data } = await this.api.post<TAdminPracticeInviteAllResponse>(
            API_PREFIX_ADMIN + '/practices/invite-all'
        );

        return data;
    };

    updateInfoAll = async (): Promise<TAdminPracticeUpdateInfoAllResponse> => {
        const { data } = await this.api.post<TAdminPracticeUpdateInfoAllResponse>(
            API_PREFIX_ADMIN + '/practices/update-info-all'
        );

        return data;
    };

    async #getPaginatedPractices(
        payload: TAdminPracticesPayload
    ): Promise<TAdminPracticesResponse> {
        const { data } = await this.api.get<TAdminPracticesResponse>(
            API_PREFIX_ADMIN + '/practices',
            {
                params: payload,
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return data;
    }
}
